import { render, staticRenderFns } from "./questionUnit.vue?vue&type=template&id=09811702&scoped=true&"
import script from "./questionUnit.vue?vue&type=script&lang=js&"
export * from "./questionUnit.vue?vue&type=script&lang=js&"
import style0 from "./questionUnit.vue?vue&type=style&index=0&id=09811702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09811702",
  null
  
)

export default component.exports